import { render, staticRenderFns } from "./AttachFileField.vue?vue&type=template&id=79632780&scoped=true"
import script from "./AttachFileField.ts?vue&type=script&lang=ts&external"
export * from "./AttachFileField.ts?vue&type=script&lang=ts&external"
import style0 from "./AttachFileField.vue?vue&type=style&index=0&id=79632780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79632780",
  null
  
)

export default component.exports